import { TFunction } from 'i18next';

interface IGetCopies {
  t: TFunction;
}

interface ICopiesInfo {
  label: string;
  secondaryLabel?: string;
}

interface ICopiesCampaignDetails {
  campaignName: ICopiesInfo;
  campaignSource: ICopiesInfo;
  campaignTerm: ICopiesInfo;
  campaignLaunchDate: ICopiesInfo;
  campaignMedium: ICopiesInfo;
  campaignContent: ICopiesInfo;
  campaignEndDate: ICopiesInfo;
  campaignSourceInfo: ICopiesInfo;
  campaignTermInfo: ICopiesInfo;
  campaignConsents: ICopiesInfo;
  campaignConversionRate: ICopiesInfo;
  campaignProportion: ICopiesInfo;
}

export const getTitles = ({ t }: IGetCopies): { activeCampaigns: string; inactiveCampaigns: string } => {
  return {
    activeCampaigns: t('campaign_list.active_campaigns'),
    inactiveCampaigns: t('campaign_list.inactive_campaigns'),
  };
};

export const getCopiesCampaignDetails = ({ t }: IGetCopies): ICopiesCampaignDetails => {
  return {
    campaignName: {
      label: t('add_campaign.campaign_name.label'),
    },
    campaignSource: {
      label: t('add_campaign.campaign_source.label'),
    },
    campaignSourceInfo: {
      label: t('add_campaign.campaign_source_info.label'),
    },
    campaignTerm: {
      label: t('add_campaign.campaign_term.label'),
    },
    campaignTermInfo: {
      label: t('add_campaign.campaign_term_info.label'),
    },
    campaignLaunchDate: {
      label: t('add_campaign.campaign_launch_date.label'),
    },
    campaignMedium: {
      label: t('add_campaign.campaign_medium.label'),
    },
    campaignContent: {
      label: t('add_campaign.campaign_content.label'),
    },
    campaignEndDate: {
      label: t('add_campaign.campaign_end_date.label'),
    },
    campaignConsents: {
      label: t('add_campaign.campaign_consents.label'),
    },
    campaignConversionRate: {
      label: t('add_campaign.campaign_conversion_rate.label'),
      secondaryLabel: t('add_campaign.campaign_conversion_rate.secondaryLabel'),
    },
    campaignProportion: {
      label: t('add_campaign.campaign_proportion.label'),
      secondaryLabel: t('add_campaign.campaign_proportion.secondaryLabel'),
    },
  };
};

export const getCampaignMediumItems = (t: TFunction): Array<{ id: string; label: string }> => [
  { id: 'email', label: t('add_campaign.campaign_medium.options.email') },
  { id: 'sms', label: t('add_campaign.campaign_medium.options.sms') },
  { id: 'paid-ad', label: t('add_campaign.campaign_medium.options.paid_ad') },
  { id: 'organic-social', label: t('add_campaign.campaign_medium.options.organic_social') },
  { id: 'printed-collateral', label: t('add_campaign.campaign_medium.options.printed_collateral') },
  { id: 'pr-media', label: t('add_campaign.campaign_medium.options.public_relations') },
  { id: 'internal-communications', label: t('add_campaign.campaign_medium.options.internal_communications') },
  { id: 'website', label: t('add_campaign.campaign_medium.options.website') },
  { id: 'other', label: t('add_campaign.campaign_medium.options.other') },
];
